var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelect = function SvgIconSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".79em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 27 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.658 5.02H5.229c-.909 0-1.781.355-2.424.989a3.35 3.35 0 0 0-1.004 2.388v20.267c0 .896.361 1.755 1.004 2.388.643.634 1.515.99 2.424.99h17.143c.91 0 1.782-.356 2.425-.99a3.35 3.35 0 0 0 1.004-2.388V8.397c0-.896-.361-1.755-1.004-2.388a3.46 3.46 0 0 0-2.425-.99h-3.428m-10.286 0c0 .896.361 1.755 1.004 2.389s1.515.99 2.424.99h3.43c.908 0 1.78-.357 2.423-.99a3.35 3.35 0 0 0 1.005-2.389m-10.286 0c0-.895.361-1.755 1.004-2.388a3.46 3.46 0 0 1 2.424-.99h3.43c.908 0 1.78.356 2.423.99a3.35 3.35 0 0 1 1.005 2.388M8.658 20.22l3.428 3.378 6.858-6.755"
  })));
};
export default SvgIconSelect;